import { createAction } from '@reduxjs/toolkit'

export const goTo = createAction('goTo');
export const doSearch = createAction('doSearch');
export const resetFilter = createAction('resetFilter');
